import { isFunction } from 'lodash'

export default {
  data () {
    return {
      states: {
        filtersMap: {}
      }
    }
  },
  methods: {
    createFiltersMap (column) {
      try {
        const { key, filters, filterMultiple, filtersSearchPlaceholder = '在筛选项中搜索', defaultFilterValue = null } = column || {}
        if (!key) {
          return
        }
        if (!this.states.filtersMap[key]) {
          // 内置默认值
          let _defaultFilterValue = defaultFilterValue
          // 说明是使用的内部的filter
          if (Array.isArray(filters) && filters.length) {
            if (filterMultiple !== false && !Array.isArray(_defaultFilterValue)) {
              _defaultFilterValue = []
            }
          }
          this.$set(this.states.filtersMap, key, {
            values: _defaultFilterValue,
            column,
            filterSearchValue: '',
            filteredValue: _defaultFilterValue,
            filtersSearchPlaceholder,
            filterMultiple
          })
        }
      } catch (error) {
        console.error('createFiltersMap：', error)
      }
    },
    resetFilter (column) {
      const { key, filters } = column
      const filterMultiple = column.filterMultiple !== false
      if (!this.states.filtersMap[key]) {
        this.states.filtersMap[key] = {}
      }
      // 为什么用两个？一个是确认,一个是仅选择。
      const value = Array.isArray(filters) && filterMultiple ? [] : null
      this.states.filtersMap[key]['filteredValue'] = value
      this.states.filtersMap[key]['values'] = value
      this.states.filtersMap[key]['filterSearchValue'] = ''
    },
    filtersChange (val, column) {
      const { key } = column
      if (!this.states.filtersMap[key]) {
        this.states.filtersMap[key] = {}
        this.$set(this.states.filtersMap, key, {})
      }
      this.$set(this.states.filtersMap[key], 'filteredValue', val)
    },
    filterSearchChange (val, column) {
      const { key } = column
      if (!this.states.filtersMap[key]) {
        this.states.filtersMap[key] = {}
      }
      this.states.filtersMap[key]['filterSearchValue'] = val
    },
    onFilter (val, column) {
      this.filterChange(val, column)
    },
    updateFilters (values, column) {
      if (!column) {
        return
      }
      // 兜底
      if (Array.isArray(column.filters)) {
        if (column.filterMultiple !== false) {
          if (!values || !Array.isArray(values)) {
            values = []
          }
        } else {
          if (!values) {
            values = null
          }
        }
      }
      const { key } = column || {}
      if (key) {
        this.states.filtersMap[key].values = values
      }
    },
    filterChange (values, column) {
      this.updateFilters(values, column)
      this.updateTableData({
        isResetScroll: false,
      })
      const { scrollPos } = this.states
      const { scrollTop, scrollLeft } = scrollPos
      this.$nextTick(() => {
        this.table.scrollTo({ scrollTop, scrollLeft })
      })
      this.table.$emit('filter-change', this.states.filtersMap)
    },
    clearFilter () {
      this.states.filtersMap = {}
      this.table.$emit('filter-change', {})
    }
  }
}


export function filterData(formatDataResult, { store } = {}) {
  try {
    const { filtersMap } = store.states
    if (!filtersMap) return formatDataResult
    const filtersMapKeys = Object.keys(filtersMap)
    if (!filtersMapKeys.length) {
      return formatDataResult
    }
    let res = formatDataResult.tableData
    res = res.filter((row) => {
      const isEffectiveIter = (k) => {
        const column = filtersMap[k].column || {}
        const { values } = filtersMap[k] || {}
        const effectiveValue = column.filterMultiple !== false && Array.isArray(values) ? values.length : values !== null
        const isRomte = isFunction(column.onFilter)
        return effectiveValue && !isRomte && isFunction(column.filterMethod)
      }
      const effectiveFilters = filtersMapKeys.filter(k => isEffectiveIter(k))
      const isEffective = effectiveFilters.every(k => {
        const { column, values } = filtersMap[k] || {}
        const multipleFilters = column.filterMultiple !== false
        if (multipleFilters && Array.isArray(values) && values.length) {
          return values.some(value => column.filterMethod.call(null, value, row, column))
        } else {
          return column.filterMethod.call(null, values, row, column)
        }
      })
      return isEffective
    })
    return {
      ...formatDataResult,
      tableData: res
    }
  } catch (error) {
    console.error('filterData：', error)
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/store/modules/filter.js